export default __webpack_public_path__ + "static/media/interpreting_carousel_2.fbcede7b.jpg";